module.exports = __webpack_public_path__ + "static/bg.d639921d.png";